import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumOrderSortBy implements BaseEnumType {
  private static allValues: EnumOrderSortBy[] = []; // make sure this is top-most
  
  public static none = new EnumOrderSortBy(0, "None", "enum_order_sort_by_none");
  public static id = new EnumOrderSortBy(1, "Id", "enum_order_sort_by_id");
  public static deliveryDate = new EnumOrderSortBy(2, "DeliveryDate", "enum_order_sort_by_delivery_date");
  public static despatchDate = new EnumOrderSortBy(3, "DespatchDate", "enum_order_sort_by_despatch_date");
  public static createdAt = new EnumOrderSortBy(4, "CreatedAt", "enum_order_sort_by_created_at");
  public static lastUpdatedAt = new EnumOrderSortBy(5, "LastUpdatedAt", "enum_order_sort_by_last_updated_at");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumOrderSortBy.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumOrderSortBy.none; }
  public isId() { return this === EnumOrderSortBy.id; }
  public isDeliveryDate() { return this === EnumOrderSortBy.deliveryDate; }
  public isDespatchDate() { return this === EnumOrderSortBy.despatchDate; }
  public isCreatedAt() { return this === EnumOrderSortBy.createdAt; }
  public isLastUpdatedAt() { return this === EnumOrderSortBy.lastUpdatedAt; }

  public static getValues(): readonly EnumOrderSortBy[] {
    return EnumOrderSortBy.allValues;
  }

  public static getValuesExcept0(): readonly EnumOrderSortBy[] {
    return EnumOrderSortBy.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumOrderSortBy {
    const found = EnumOrderSortBy.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumOrderSortBy - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumOrderSortBy): EnumOrderSortBy {
    const found = name ? EnumOrderSortBy.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumOrderSortBy - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumOrderSortBy>): boolean {
    return this.key === other?.key;
  }
}